import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const FALLBACK_LOCALE = 'fi'
const SUPPORTED_LANGUAGES = ['en', 'et', 'fi', 'ru', 'sv', 'lv', 'lt', 'de']
const SUPPORTED_COUNTRIES = ['EE', 'FI', 'LV', 'XZ', 'SE', 'DE']
const SUPPORTED_TEMPLATE_IDS = ['UNIVERSAL', 'SERIAL_TICKETS']
const TRANSLATION_PROJECT_IDS = [1, 3]

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: resolveLocale(window.location.search),
    fallbackLng: false,
    load: 'languageOnly',
    backend: {
      loadPath: '{{lng}}',
      request: (options, lng, payload, callback) => {
        const params = buildParams({
          projectIds: TRANSLATION_PROJECT_IDS,
          templateIds: SUPPORTED_TEMPLATE_IDS,
          locales: [lng, FALLBACK_LOCALE]
        })

        fetch(`/translation-service-api/lite-translations?${params}`)
          .then(res => {
            if (!res.ok) throw new Error(`TS returned ${res.status}`)
            return res.json()
          })
          .then(data => {
            const translationsWithFallback = {
              ...buildTranslations(data, FALLBACK_LOCALE),
              ...buildTranslations(data, lng)
            }
            callback(null, { status: 200, data: JSON.stringify(translationsWithFallback) })
          })
          .catch(err => callback(err))
      }
    },
    supportedLngs: getSupportedLocales(),
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  })

export function resolveLocale(search) {
  const detected = convertSearchStringToLocale(search)
  if (!detected) return FALLBACK_LOCALE
  const supported = getSupportedLocales()
  if (supported.includes(detected)) return detected
  const languageOnly = detected.split('-')[0]
  if (supported.includes(languageOnly)) return languageOnly
  return FALLBACK_LOCALE
}

export function convertSearchStringToLocale(search) {
  const searchParams = new URLSearchParams(search)
  const language = searchParams.get('locale')
  const country = searchParams.get('country')?.toUpperCase()
  if (!language) {
    if (country) return `${FALLBACK_LOCALE}-${country}`
    return undefined
  }
  if (!country) return language
  if (language.length === 5) return `${language.substring(0, 2)}-${country}`
  return `${language}-${country}`
}

export function getSupportedLocales() {
  return SUPPORTED_LANGUAGES.flatMap(language => {
    const languageAndCountryPairs = SUPPORTED_COUNTRIES.map(country => `${language}-${country}`)
    return [language, ...languageAndCountryPairs]
  })
}

function buildParams({ projectIds, templateIds, locales }) {
  const params = new URLSearchParams()
  templateIds.forEach(id => params.append('templateIds', id))
  projectIds.forEach(id => params.append('projectIds', id))
  locales.forEach(l => params.append('locales', l.toUpperCase()))

  return params
}

function buildTranslations(data, lng) {
  const result = {}
  data.forEach(({ key, localizations }) => {
    const localization = localizations.find(l => l.locale === lng.toUpperCase())

    if (localization?.value?.templateId === 'UNIVERSAL') {
      result[key] = localization.value.value
    }
    if (localization?.value?.templateId === 'SERIAL_TICKETS') {
      result[`${key}.title`] = localization.value.title
      result[`${key}.tooltipInfo`] = localization.value.tooltipInfo
      result[`${key}.tooltipTitle`] = localization.value.tooltipTitle
    }
  })

  return result
}
